import TagManager from 'react-gtm-module';

interface EventWithoutProperties {
  event:
    | 'surveySkipped'
    | 'addedReferralCode'
    | 'userCopyID'
    | 'surprisePerkClaimPerkLater'
    | 'surprisePerkClaimPerkNow'
    | 'surprisePerkModalOpened'
    | 'onboardingView'
    | 'userUpdateDetails'
    | 'restaurantVisitToolTipViewed'
    | 'virtualPageview'
    | 'clickOnClickAndCollect'
    | 'signUp'
    | 'marketingPreference';
}

type RetryEvent = 'Welcome Voucher Retry Fix' | 'Onboarding Status Retry Fix';

interface WelcomeVoucherRetryFixEvent {
  event: RetryEvent;
  numberOfRetryAttempts: number;
  isWelcomeVoucherReturned: boolean;
}

interface DataFetchRetryEvent {
  event: RetryEvent;
  numberOfRetryAttempts: number;
  isDataReturned: boolean;
}

interface UserSignOutErrorEvent {
  event: 'userSignOutError';
  data: unknown;
}

// Merge with OfferPriceEvent when reward prop no longer needed
interface PriceEvent {
  event: 'carouselOpenModal' | 'storeOpenModal';
  reward: string;
  offer: string;
  price: number;
}

// Replaced with OfferPriceEvent
// Remove when no longer needed
interface RewardPriceEvent {
  event: 'rewardPurchase';
  reward: string;
  price: number;
}

// Replaced with OfferViewTermsEvent
// Remove when no longer needed
interface RewardEvent {
  event: 'rewardViewTerms';
  reward: string;
}

interface OfferPriceEvent {
  event: 'offerPurchase';
  offer: string;
  price: number;
}

interface OfferViewTermsEvent {
  event: 'offerViewTerms';
  offerTitle: string;
}

// Remove key reward when no longer needed.
interface VoucherEvent {
  event: 'receivedSpinToWinPerk' | 'receivedSurprisePerk' | 'walletOpenModal';
  reward: string;
  voucher: string;
}

interface FaqEvent {
  event: 'faqClick';
  faqCategory: string;
  faqCopy: string;
}

interface TitleEvent {
  event: 'clickReferAFriend' | 'copyReferralCode' | 'welcomeOfferClick';
  title: string;
}

interface LocationEvent {
  event: 'userCopyID' | 'ZsActivity';
  location: string;
}

interface OnboardingEvent {
  event: 'onboardingSkip' | 'onboardingNext';
  title?: string;
}

interface DescriptionEvent {
  event: 'userRedeemedCode';
  description: string;
}

interface MarketingEvent {
  event: 'marketingPreference';
  optedIn: boolean | undefined;
  location: string;
}

interface WinASliceEvent {
  event: 'winASlice';
  title: string;
}

export interface InstallationEvent {
  event: 'addToHomeScreen';
  operationSystem: 'iOS' | 'Android' | null;
  location: 'Carousel' | 'Landing Page';
}
interface AccessLocationEvent {
  event: 'accessLocation';
  location: 'Home Screen' | 'Browser';
  operationSystem: 'iOS' | 'Android' | null;
}

export type AnalyticsEvent =
  | EventWithoutProperties
  | WelcomeVoucherRetryFixEvent
  | DataFetchRetryEvent
  | UserSignOutErrorEvent
  | RewardPriceEvent
  | PriceEvent
  | RewardEvent
  | OfferPriceEvent
  | OfferViewTermsEvent
  | VoucherEvent
  | FaqEvent
  | TitleEvent
  | DescriptionEvent
  | LocationEvent
  | OnboardingEvent
  | MarketingEvent
  | WinASliceEvent
  | InstallationEvent
  | AccessLocationEvent;

export const pushAnalyticsEvent = (analyticsEventData: AnalyticsEvent) =>
  TagManager.dataLayer({ dataLayer: analyticsEventData });
